import { Pipe, PipeTransform } from '@angular/core';

import { ClaimsService } from '@core/authentication/claims.service';
import { Claims } from '@core/authentication/claims';

@Pipe({
  name: 'referrerArrangementDisabled'
})
export class ReferrerArrangementDisabledPipe implements PipeTransform {
  constructor(private claimsService: ClaimsService) {}

  /**
   * Determines if the Referrer Arrangement section should be disabled
   * based on the Affiliate ID value and user role.
   * 
   * @param affiliateId The affiliate ID value
   * @returns true if referrer arrangement should be disabled, false otherwise
   */
  transform(affiliateId: string | null): boolean {
    // Network admin can edit both
    if (this.claimsService.userRole === Claims.UserRoles.NetworkAdministrator) {
      return false;
    }

    return !!(affiliateId && affiliateId.trim());
  }
}

